<p-sidebar (onHide)="othersUploadPopupClose()" [(visible)]="uploadOthersDisplay" [showCloseIcon]="false" class="sidebar-sm eSockUpdate-confirmation-dialog"
           position="right">
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
      <div class="flex align-items-center gap-2">
        <h2 class="gc-form-heading">Upload Other Document</h2>
      </div>
      <div>
        <span (click)="othersUploadPopupClose()" class="cursor-pointer"><em class="pi pi-times"></em></span>
      </div>
    </div>
    <br />
    <br />
  </ng-template>
  <form #eSockForm="ngForm">
    <div class="popup-wrapper" >
      <div class="field" >
        <ng-container>
          <label>Patient</label>
          <div class="p-inputgroup table-search-wrapper">
            <span class="p-inputgroup-addon"><img alt="search.svg" src="../../assets/images/search.svg"/></span>
            <input [placeholder]="'Search & select patient by mrn'" class="table-search-field w-full"  type="text"/>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="popup-wrapper">
      <div class="gc-form-section">
        <div class="gc-form-section-heading">
          <h3>Upload file</h3>
        </div>
        <div class="sidebar-form">
          <div class="grid p-fluid">
            <div *ngIf="showeSockDragAndDrop" class="dropzone" fileDragDrop>
              <div class="text-wrapper">
                <div class="dropFile-wra">
                  <input (change)="handleFileUpload($event)" [(ngModel)]="eSockSubmissionForm.eSockFile" accept="application/pdf" id="file" name="file" required type="file">
                  <div class="flex flex-column align-items-center justify-content-center gap-4">
                    <img alt="File upload" src="../../assets/images/fileupload.svg">
                    <label class="textLink" for="file">Drag and drop file here or <u>Choose file</u></label>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="showUpdateAndDeleteEsock" class="fileupload-info">
              <div class="flex align-items-center gap-3 w-8">
                <img alt="" src="../../assets/images/Document.svg">
                <label class="fileupload-text">{{eSockFileName}}</label>
              </div>
              <div class="flex align-items-center gap-3 w-4">
                <button (click)="deleteEsockFile()" class="btn-cancel p-button button-sm">Delete</button>
                <button (click)="updateEsockFile()" class="p-button button-sm">Update eDOC</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gc-form-section">
        <div class="gc-form-section-heading">
          <h3>Preferred Method</h3>
        </div>
        <div class="sidebar-form">
          <div class="grid p-fluid">
            <div class="col-12">
              <div class="flex align-items-center justify-content-between">
                <label>Email<span class="red">*</span></label>
                <div class="flex align-items-center gap-2">
                  <p-checkbox (onChange)="changeCheckboxValue()" [(ngModel)]="eSockSubmissionForm.email.preferred" [binary]="true" inputId="email" name="emailPrefferd"></p-checkbox>
                  <label>Send via Email</label>
                </div>
              </div>
              <span class="p-input-icon-left">
              <span class="gc-input-icon"><img alt="email-icon.svg" src="../../assets/images/email-icon.svg"></span>
              <input [(ngModel)]="eSockSubmissionForm.email.email" class="p-inputtext" email id="email" name="email" pInputText placeholder="Email" required type="email"/>
            </span>
            </div>
          </div>
          <div class="grid p-fluid">
            <div class="col-12">
              <div class="flex align-items-center justify-content-between">
                <label>Phone<span class="red">*</span></label>
                <div class="flex align-items-center gap-2">
                  <p-checkbox (onChange)="changeCheckboxValue()" [(ngModel)]="eSockSubmissionForm.phoneNumber.preferred" [binary]="true" inputId="phone" name="phonePreffered"></p-checkbox>
                  <label>Send via Phone</label>
                </div>
              </div>
              <div class="flex gc-dialCode">
                <p-dropdown [(ngModel)]="eSockSubmissionForm.phoneNumber.countryCode" [options]="countries" name="countryCode" optionLabel="dial_code" optionValue="dial_code">
                  <ng-template let-country pTemplate="selectedItem">
                    <span class="fi fi-{{country.code.toLowerCase()}} countryflag"></span>
                    <span class="country-code"> {{country.dial_code}}</span>
                  </ng-template>
                  <ng-template let-country pTemplate="item">
                    <span class="fi fi-{{country.code.toLowerCase()}} countryflag"></span>
                    <span class="country-code"> {{country.dial_code}}</span>
                  </ng-template>
                </p-dropdown>
                <p-inputMask [(ngModel)]="eSockSubmissionForm.phoneNumber.number" aria-required="true" class="w-full" mask="999-999-9999" name="phoneNumber" placeholder="(XXX) XXX-XXXX"></p-inputMask>
              </div>

            </div>
          </div>
          <div class="grid p-fluid">
            <div class="col-12">
              <div class="flex align-items-center justify-content-between">
                <label>DOB<span class="red">*</span></label>
              </div>
              <span class="p-input-icon-left">
              <span class="gc-input-icon">
                <img alt="calendar.svg" src="assets/images/calendar.svg">
              </span>

              <p-calendar [(ngModel)]="eSockSubmissionForm.dob" [required]="true" class="w-full disable-calendar"
                          dateFormat="{{dobDateFormat}}" dateMask="99/99/9999" name="dob" placeholder="mm/dd/yyyy"></p-calendar>
                <!--              <input id="dob" type="text" [(ngModel)]="eSockSubmissionForm.dob" required email pInputText name="dob" placeholder="mm/dd/yyyy" class="p-inputtext"/>-->
            </span>
            </div>
          </div>
          <div class="grid p-fluid">
            <div class="col-12">
              <div class="flex align-items-center gap-2">
                <p-checkbox [(ngModel)]="eSockSubmissionForm.isChecked" [binary]="true" name="myCheckbox" value="someValue"></p-checkbox>
                <label>Yes! I agree to receive email and SMS</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-container px-4">
      <button (click)="othersUploadPopupClose()" class="btn-cancel w-3" pButton>Close</button>
      <button (click)="addeSocToSubmission(true)" [disabled]="!eSockForm.form.valid ||!isPhoneNumberValid() ||  isPreferredContactSelected || !isFileUploadComplete" class="w-3" pButton>Save</button>
    </div>
  </form>
</p-sidebar>
